import FreddieImage from '@app/assets/images/about-us/team/Freddie.jpg'
import SaschaImage from '@app/assets/images/about-us/team/Sascha-two.jpg'
import { useTranslations } from '@i18n/useLanguage'
import {
  ContactCard,
  ContactPerson,
} from '@app/components/blocks/contactCard/ContactCard'

export const ForMunicipalitiesContactCard = () => {
  const t = useTranslations()

  const CONTACT_PEOPLE: ContactPerson[] = [
    {
      imageSrc: SaschaImage,
      imageAlt: 'Portrait of Sascha Glasl',
      name: 'Sascha \nGlasl',
      role: t.app.forMunicipalities.contact.people.sascha.role,
      buttonLabel: t.app.forMunicipalities.contact.buttonLabel,
      buttonLink: 'https://meetings-eu1.hubspot.com/sascha-glasl',
    },
    {
      imageSrc: FreddieImage,
      imageAlt: 'Portrait of Freddie Aldershoff',
      name: 'Freddie Aldershoff',
      role: t.app.forMunicipalities.contact.people.freddie.role,
      buttonLabel: t.app.forMunicipalities.contact.buttonLabel,
      buttonLink:
        'https://meetings-eu1.hubspot.com/freddie-aldershoff/freddie-demo',
    },
  ]

  return (
    <ContactCard
      title={t.app.forMunicipalities.contact.title}
      description={t.app.forMunicipalities.contact.description}
      contactPeople={CONTACT_PEOPLE}
    />
  )
}
